var channelOverview = function(){
  var container;
  var lists = [];
  
  var _init = function(){
    container = document.getElementById('allChannelsContainer');
    lists = container.getElementsByClassName('m-all-channels-overview-section__list');

    _listCheckForColumns(lists)
  };

  var _listCheckForColumns = function(lists){
    [].map.call(lists, function(list){
      if(_listCountChildren(list) < 5){
        list.classList.add('no-column');
      }
    });
  };

  var _listCountChildren = function(list){
    var children = list.getElementsByTagName('li').length;
    return children;
  }

  return {
    setColumns: _init
  }
}();

if (document.getElementById('allChannelsContainer')) {
  channelOverview.setColumns();
}